import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useLocation } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import Select from "react-select";
import DaySelector from "../Components/DaySelector";
import Selector from "../Components/DayTimeSelector";
import Daytimeselector from "../Components/DayTimeSelector";
import DayTimeSelector from "../Components/DayTimeSelector";

const PhysicianAvailablity = () => {
	let { state } = useLocation();
	const specializationOptions = [
		{ value: "Monday", label: "Monday" },
		{ value: "Tuesday", label: "Tuesday" },
		{ value: "Wednesday", label: "Wednesday" },
		{ value: "Thursday", label: "Thursday" },
		{ value: "Friday", label: "Friday" },
		{ value: "Saturday", label: "Saturday" },
		{ value: "Sunday", label: "Sunday" },
	];

	const [selectedSpecializations, setSelectedSpecializations] =
		useState("Select days");
	return (
		<>
			<Header />
			<PageHeader pagename="SignUp" />
			<section className="signup availablity">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Show your Availablity
								</h2>
								<form>
									<div className="row mb-5">
										<div className="col-lg-11 mx-auto">
											<div className="select-days">
												<h4 className="level-5 main-heading-font dark-color">
													Select Days
												</h4>
												<DaySelector toke={state?.token} page="signUp" />
												<div className="skip_btn">
													{state?.token ? (
														<Link to="/sign-in">Skip</Link>
													) : (
														<Link to="/physician-personal-info">Skip</Link>
													)}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <DayTimeSelector /> */}
			{/* <DaySelector /> */}

			<Footer />
		</>
	);
};

export default PhysicianAvailablity;
